export class Tip {
  private tips: Number[];
  private title: String;
  private subtitle: String;

  constructor(tips: Number[]) {
    this.tips = tips;
    this.title = "Tip your bartender now?";
    this.subtitle =
      "Your tip is seent to the bartender at the end of the night!";
  }
}
